import { render, staticRenderFns } from "./exportRecord.vue?vue&type=template&id=22f1ed85&"
import script from "./exportRecord.vue?vue&type=script&lang=js&"
export * from "./exportRecord.vue?vue&type=script&lang=js&"
import style0 from "./exportRecord.vue?vue&type=style&index=0&id=22f1ed85&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports